import {BaseContainerModel} from '../../base-container.model';


export class BankReconGuidModel extends BaseContainerModel {
  bank_recon_guid:string;
}
